import { createReducer, PayloadAction } from '@reduxjs/toolkit'

import { addMovingAverage, chartActive, chartSize, removeMovingAverage, toLiquidity, updateChart, updateTimeFrame } from './actions'
export const TimeFrameOptions: Record<string, number> = {
  ['5m']: 5 * 60,
  ['15m']: 15 * 60,
  ['1h']: 60 * 60,
  ['4h']: 4 * 60 * 60,
  ['1d']: 24 * 60 * 60,
  ['1w']: 7 * 24 * 60 * 60,
}
export type movingAverage = {
  color: string
  number: number
  type: string
}
export interface WithChartState {
  [path: string]: ChartState
}
export interface ChartState {
  timeFrame: number
  line: boolean
  movingAverage: Record<number, movingAverage>
  active: boolean
  chartSize: { width: number; height: number }
  LPLink: boolean
}

export const initialState: ChartState = {
  timeFrame: TimeFrameOptions['1w'],
  line: false,
  movingAverage: {},
  active: true,
  chartSize:{
    width:0,
    height:0
  },
  LPLink: false
}

export default createReducer(initialState, (builder) =>
  builder
    .addCase(updateTimeFrame, (state, action) => {
      state.timeFrame = action.payload.timeframe
    })
    .addCase(chartSize, (state, action) => {
      state.chartSize = action.payload
    })
    .addCase(toLiquidity, (state, action) => {
      state.LPLink = action.payload
    })
    .addCase(updateChart, (state, action) => {
      state.line = action.payload.line
    })
    .addCase(chartActive, (state, action) => {
      state.active = action.payload.active
    })
    .addCase(addMovingAverage, (state, { payload: { number, color, type } }) => {
      let index = 0
      for (const key of Object.keys(state.movingAverage)) {
        if (Number(key) !== index) {
          break
        }
        index++
      }
      state.movingAverage[index] = { color, number, type }
    })
    .addCase(
      removeMovingAverage,
      (state, action: PayloadAction<{ type: string; number: number }>) => {
        const { type, number } = action.payload
        const maKeys = Object.keys(state.movingAverage)
        let index = 0
        for (const key of Object.values(state.movingAverage)) {
          if (key.number === number && key.type === type) {
            break
          }
          index++
        }
        delete state.movingAverage[Number(maKeys[index])]
      }
    )
)
